module.exports = __webpack_public_path__ + "static/img/xkzx.f679f7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xkzx.png
// module id = 6sQc
// module chunks = 128